import { render, staticRenderFns } from "./PJProposalTerritoriesCovered.vue?vue&type=template&id=73906892"
import script from "./PJProposalTerritoriesCovered.vue?vue&type=script&lang=js"
export * from "./PJProposalTerritoriesCovered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports